import { useCallback } from 'react';
import { formatUnits, parseUnits } from 'ethers/lib/utils';
import { BigNumber } from 'ethers';
import { UserTotalDeposit } from './useUserTotalDeposits';
import useMockUserLockUps from './useMockUserLockUps';

const useMockUserTotalDeposits = () => {
    const { userLockUps } = useMockUserLockUps();

    let totalDepositAssetAllPools = '0';

    const totalDepositsPerPool = Object.values(userLockUps ?? {}).map((userLockUp) => {
        const shareDecimals = userLockUp.liquidityPool.decimals;
        const decimals = 6;

        const {
            lockedTotalAssets,
            lockedTotalLp,
            totalAssets,
            totalLp,
            unlockedTotalAssets,
            unlockedTotalLp,
        } = userLockUp.details.reduce(
            (
                total,
                {
                    lockedAssets,
                    unlockedAssets,
                    totalAssets,
                    lockedLp,
                    unlockedLp,
                    totalLp,
                }
            ) => {
                return {
                    ...total,
                    lockedTotalAssets: total.lockedTotalAssets.add(
                        parseUnits(lockedAssets, decimals)
                    ),
                    unlockedTotalAssets: total.unlockedTotalAssets.add(
                        parseUnits(unlockedAssets, decimals)
                    ),
                    totalAssets: total.totalAssets.add(
                        parseUnits(totalAssets, decimals)
                    ),
                    lockedTotalLp: total.lockedTotalLp.add(
                        parseUnits(lockedLp, shareDecimals)
                    ),
                    unlockedTotalLp: total.unlockedTotalLp.add(
                        parseUnits(unlockedLp, shareDecimals)
                    ),
                    totalLp: total.totalLp.add(
                        parseUnits(totalLp, shareDecimals)
                    ),
                };
            },
            {
                totalAssets: BigNumber.from(0),
                unlockedTotalAssets: BigNumber.from(0),
                lockedTotalAssets: BigNumber.from(0),
                totalLp: BigNumber.from(0),
                unlockedTotalLp: BigNumber.from(0),
                lockedTotalLp: BigNumber.from(0),
            }
        );

        totalDepositAssetAllPools = formatUnits(
            parseUnits(totalDepositAssetAllPools, decimals).add(totalAssets),
            decimals
        );

        return {
            liquidityPool: userLockUp.liquidityPool,
            lockedTotalAssets: formatUnits(lockedTotalAssets, decimals),
            lockedTotalLp: formatUnits(lockedTotalLp, shareDecimals),
            totalAssets: formatUnits(totalAssets, decimals),
            totalLp: formatUnits(totalLp, shareDecimals),
            unlockedTotalAssets: formatUnits(unlockedTotalAssets, decimals),
            unlockedTotalLp: formatUnits(unlockedTotalLp, shareDecimals),
            totalSubgraphDepositAsset: '0',
        };
    });

    const userTotalDeposits: UserTotalDeposit = {
        totalDepositsPerPool,
        totalDepositAssetAllPools,
    };

    const updateUserTotalDeposits = useCallback(() => {}, []);

    return {
        userTotalDeposits,
        isLoading: false,
        error: undefined,
        updateUserTotalDeposits,
    };
};

export default useMockUserTotalDeposits;
